import { CUSTOMER_PORTAL_URL } from 'react-native-dotenv'

const baseUrl = CUSTOMER_PORTAL_URL || ''

export function cpUrl(establishmentId: string, path = ''): string {
  return `${baseUrl}/${establishmentId}${path}`
}

export const customerPortalLinks = {
  login: (establishmentId: string, returnTo?: string, email?: string) => {
    const params = new URLSearchParams()
    if (returnTo) params.set('returnTo', returnTo)
    if (email) params.set('email', email)
    const query = params.toString()
    return cpUrl(establishmentId, `/login${query ? `?${query}` : ''}`)
  },

  profile: (establishmentId: string) =>
    cpUrl(establishmentId, '/profile/manage'),

  appointments: (establishmentId: string) =>
    cpUrl(establishmentId, '/profile/appointments'),

  punchCards: (establishmentId: string) =>
    cpUrl(establishmentId, '/punch-cards'),

  myPunchCards: (establishmentId: string) =>
    cpUrl(establishmentId, '/profile/punch-cards'),
}
